"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerSeasonSchema = void 0;
const zod_1 = require("zod");
const player_1 = require("./player");
const season_1 = require("./season");
exports.PlayerSeasonSchema = zod_1.z.object({
    player: player_1.PlayerSchema,
    season: season_1.SeasonSchema,
});
//# sourceMappingURL=playerSeason.js.map